/**
 * Gutshof theme JS — minimal, dependency-free.
 */
(() => {
  // --- Close pop-out <details> (mobile nav, account menu) on outside click ---
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details[data-mobile-nav][open], details[data-account-menu][open]').forEach((details) => {
      if (!details.contains(e.target)) details.removeAttribute('open');
    });
  });

  // --- Mobile nav: per-item submenu accordion (chevron toggles children) ---
  document.querySelectorAll('[data-submenu-toggle]').forEach((btn) => {
    const submenu = btn.closest('li')?.querySelector('[data-submenu]');
    if (!submenu) return;
    const chevron = btn.querySelector('svg');
    btn.addEventListener('click', () => {
      const open = submenu.classList.toggle('hidden') === false;
      btn.setAttribute('aria-expanded', String(open));
      if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : '';
    });
  });

  // --- Product page: variants, gallery, quantity ---
  document.querySelectorAll('[data-product-root]').forEach(initProduct);

  function initProduct(root) {
    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    } catch (_) { /* leave empty */ }

    const idInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-button]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const availEl = root.querySelector('[data-availability]');
    const availText = root.querySelector('[data-availability-text]');

    // Gallery — thumbnails swap the main image
    const mainImage = root.querySelector('[data-main-image]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const showThumb = (btn) => {
      if (!mainImage || !btn) return;
      mainImage.src = btn.dataset.fullSrc;
      mainImage.srcset = btn.dataset.fullSrcset || '';
      mainImage.alt = btn.dataset.fullAlt || '';
      thumbs.forEach((t) => {
        if (t === btn) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    };
    thumbs.forEach((btn) => btn.addEventListener('click', () => showThumb(btn)));

    // Variant resolution from pill radio groups (one fieldset per option)
    const optionGroups = [...root.querySelectorAll('[data-option-group]')];
    const syncVariant = () => {
      const chosen = optionGroups.map((g) => g.querySelector('input:checked')?.value);
      const match = variants.find((v) => v.options.every((value, i) => value === chosen[i]));
      const soldOutLabel = addBtn?.dataset.labelSoldOut || '';

      if (!match) {
        // Combination doesn't exist as a variant
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldOutLabel; }
        if (availEl) availEl.dataset.state = 'sold-out';
        if (availText) availText.textContent = soldOutLabel;
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (compareEl) {
        compareEl.textContent = match.compare || '';
        compareEl.classList.toggle('hidden', !match.compare);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.labelAdd : soldOutLabel;
      }
      if (availEl) availEl.dataset.state = match.available ? 'available' : 'sold-out';
      if (availText) {
        availText.textContent = match.available
          ? availEl?.dataset.labelInStock || availText.textContent
          : soldOutLabel;
      }
      if (match.media) {
        const thumb = thumbs.find((t) => t.dataset.mediaId === String(match.media));
        if (thumb) showThumb(thumb);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };
    optionGroups.forEach((g) => g.addEventListener('change', syncVariant));

  }

  // --- Quantity steppers (product page + cart) ---
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    const step = (delta) => {
      const min = parseInt(input.min || '1', 10);
      const next = (parseInt(input.value, 10) || min) + delta;
      input.value = Math.max(min, next);
    };
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => step(-1));
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => step(1));
  });

  // --- Quick add to cart (product cards) ---
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
    } catch (_) { /* leave count as-is */ }
  }
  document.querySelectorAll('[data-quick-add]').forEach((form) => {
    const btn = form.querySelector('[data-quick-add-btn]');

    // Size pills: switch the variant id, price and availability on the card.
    const idInput = form.querySelector('[data-qa-id]');
    const priceEl = form.closest('article')?.querySelector('[data-card-price]');
    const radios = form.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (idInput) idInput.value = radio.value;
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        if (btn) {
          const avail = radio.dataset.available === 'true';
          btn.disabled = !avail;
          if (!btn.dataset.busy) btn.textContent = avail ? btn.dataset.labelAdd : (btn.dataset.labelSoldOut || btn.textContent);
        }
      });
    });
    // Initial price = the pre-selected size's exact price (drops the "ab").
    const checked = form.querySelector('input[type="radio"]:checked');
    if (checked && priceEl && checked.dataset.price) priceEl.textContent = checked.dataset.price;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!btn || btn.dataset.busy) return;
      btn.dataset.busy = '1';
      const label = btn.dataset.labelAdd || btn.textContent;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCartCount();
        btn.textContent = btn.dataset.labelAdded || '✓';
        btn.classList.add('is-added');
        setTimeout(() => {
          btn.textContent = label;
          btn.classList.remove('is-added');
          delete btn.dataset.busy;
        }, 1600);
      } catch (_) {
        delete btn.dataset.busy;
        form.submit(); // no-JS fallback: normal /cart/add post
      }
    });
  });

  // --- Read more: clamp long text blocks (e.g. collection descriptions) ---
  document.querySelectorAll('[data-readmore]').forEach((wrap) => {
    const content = wrap.querySelector('[data-readmore-content]');
    const btn = wrap.querySelector('[data-readmore-toggle]');
    if (!content || !btn) return;
    if (content.scrollHeight <= content.clientHeight + 12) {
      // Short text — no clamp needed
      btn.remove();
      content.classList.remove('max-h-44', 'overflow-hidden');
      wrap.querySelector('.pointer-events-none')?.remove();
      return;
    }
    btn.addEventListener('click', () => {
      const expanded = wrap.toggleAttribute('data-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
    });
  });

  // --- Deferred section content (e.g. product recommendations) ---
  // The element carries a Section Rendering API URL; we fetch the section and
  // swap in its [data-section-content] if it actually has content.
  document.querySelectorAll('[data-section-url]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.sectionUrl);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-section-content]');
      const target = el.querySelector('[data-section-content]');
      if (fresh && target && fresh.children.length > 0) target.replaceWith(fresh);
    } catch (_) { /* keep server-rendered fallback */ }
  });

  // --- Click-to-load video embeds (privacy: no third-party scripts until play) ---
  function toEmbedSrc(url) {
    let u;
    try { u = new URL(url); } catch (_) { return null; }
    // Only ever iframe http(s) — never javascript:/data:/etc.
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    const h = u.hostname.replace(/^www\./, '');
    // Exact host or true subdomain — so "evilyoutube.com" can't pose as YouTube.
    const isYouTube = h === 'youtube.com' || h.endsWith('.youtube.com');
    const isYouTuBe = h === 'youtu.be';
    const isVimeo = h === 'vimeo.com' || h.endsWith('.vimeo.com');
    const isInsta = h === 'instagram.com' || h.endsWith('.instagram.com');
    if (isYouTuBe) return `https://www.youtube-nocookie.com/embed/${u.pathname.slice(1)}?autoplay=1`;
    if (isYouTube) {
      if (u.pathname.startsWith('/embed/')) return `${url}${url.includes('?') ? '&' : '?'}autoplay=1`;
      const id = u.searchParams.get('v');
      if (id) return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
    }
    if (isVimeo) {
      const id = u.pathname.split('/').filter(Boolean).pop();
      if (id) return `https://player.vimeo.com/video/${id}?autoplay=1`;
    }
    if (isInsta) {
      const p = u.pathname.replace(/\/embed\/?$/, '/').replace(/\/?$/, '/');
      return `${u.origin}${p}embed`;
    }
    return null; // unrecognized provider → don't inject an iframe
  }
  document.querySelectorAll('[data-video-facade]').forEach((facade) => {
    const btn = facade.querySelector('[data-video-play]');
    btn?.addEventListener('click', () => {
      const src = toEmbedSrc(facade.dataset.embed);
      if (!src) return;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = btn.getAttribute('aria-label') || 'Video';
      iframe.loading = 'lazy';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.className = 'absolute inset-0 h-full w-full border-0';
      facade.replaceChildren(iframe);
    });
  });
})();
